'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createReducer;

exports.setSearchKeyword = setSearchKeyword;
exports.setDisplayMethod = setDisplayMethod;
exports.toggleSortDirection = toggleSortDirection;
exports.getApp = getApp;
exports.listApps = listApps;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reduxImmutablejs = require('redux-immutablejs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_SEARCH_KEYWORD = 'karmapa-digital-toolbox/app/SET_SEARCH_KEYWORD';
var SET_SORT_METHOD = 'karmapa-digital-toolbox/app/SET_SORT_METHOD';
var TOGGLE_SORT_DIRECTION = 'karmapa-digital-toolbox/app/TOGGLE_SORT_DIRECTION';

var GET_APP = 'karmapa-digital-toolbox/app/GET_APP';
var GET_APP_SUCCESS = 'karmapa-digital-toolbox/app/GET_APP_SUCCESS';
var GET_APP_FAIL = 'karmapa-digital-toolbox/app/GET_APP_FAIL';

var LIST_APPS = 'karmapa-digital-toolbox/app/LIST_APPS';
var LIST_APPS_SUCCESS = 'karmapa-digital-toolbox/app/LIST_APPS_SUCCESS';
var LIST_APPS_FAIL = 'karmapa-digital-toolbox/app/LIST_APPS_FAIL';

var initialState = _immutable2.default.Map({

  // get single app
  app: null,
  gettingApp: false,
  getAppError: null,

  // listing apps
  listingApps: false,
  listAppError: null,
  apps: [],

  displayMethod: 'grid',
  sortDirection: 'asc',
  searchKeyword: ''
});

exports.default = (0, _reduxImmutablejs.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, SET_SEARCH_KEYWORD, function (state, action) {
  return state.set('searchKeyword', action.searchKeyword);
}), (0, _defineProperty3.default)(_createReducer, SET_SORT_METHOD, function (state, action) {
  return state.set('displayMethod', action.displayMethod);
}), (0, _defineProperty3.default)(_createReducer, TOGGLE_SORT_DIRECTION, function (state) {
  var newDirection = 'asc' === state.get('sortDirection') ? 'desc' : 'asc';
  return state.set('sortDirection', newDirection);
}), (0, _defineProperty3.default)(_createReducer, GET_APP, function (state, action) {
  var apps = state.get('apps');
  // be careful, server and client immutablejs acts different
  if (_immutable2.default.List.isList(apps)) {
    apps = apps.toJS();
  }
  var foundApp = apps.find(function (app) {
    return app.id === action.id;
  });
  return state.set('app', foundApp);
}), (0, _defineProperty3.default)(_createReducer, GET_APP, function (state) {
  return state.set('gettingApp', true);
}), (0, _defineProperty3.default)(_createReducer, GET_APP_SUCCESS, function (state, action) {
  return state.set('gettingApp', false).set('app', action.result);
}), (0, _defineProperty3.default)(_createReducer, GET_APP_FAIL, function (state, action) {
  return state.set('gettingApp', false).set('getAppError', action.error);
}), (0, _defineProperty3.default)(_createReducer, LIST_APPS, function (state) {
  return state.set('listingApps', true);
}), (0, _defineProperty3.default)(_createReducer, LIST_APPS_SUCCESS, function (state, action) {
  return state.set('listingApps', false).set('apps', action.result);
}), (0, _defineProperty3.default)(_createReducer, LIST_APPS_FAIL, function (state, action) {
  return state.set('listingApps', false).set('listAppError', action.error);
}), _createReducer));
function setSearchKeyword(searchKeyword) {
  return {
    type: SET_SEARCH_KEYWORD,
    searchKeyword: searchKeyword
  };
}

function setDisplayMethod(displayMethod) {
  return {
    type: SET_SORT_METHOD,
    displayMethod: displayMethod
  };
}

function toggleSortDirection() {
  return {
    type: TOGGLE_SORT_DIRECTION
  };
}

function getApp(appId) {
  return {
    types: [GET_APP, GET_APP_SUCCESS, GET_APP_FAIL],
    promise: function promise(client) {
      return client.get('/apps/' + appId);
    }
  };
}

function listApps() {
  return {
    types: [LIST_APPS, LIST_APPS_SUCCESS, LIST_APPS_FAIL],
    promise: function promise(client) {
      return client.get('/apps');
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/app.js
 ** module id = 324
 ** module chunks = 0
 **/